module.exports = __webpack_public_path__ + "site/img/index2.70397bfd.jpg";